<template>
  <div class="menu" @click="openMenuOnClick()" @mouseenter="openMenuOnHover()" @mouseleave="closeMenuOnHoverLost()">
    <div
      class="menu__trigger"
      :class="{ 'menu__trigger--inverted' : inverted, 'menu__trigger--interactive': !inverted }"
    >
      <slot name="menu-trigger"></slot>
      <z-icon
        v-if="showDropdownIcon"
        :icon="['fas', 'sort-down']"
        class="menu__trigger__dropdown-icon"
      />
    </div>
    <transition name="backdrop">
      <div v-show="showMenu" class="menu__backdrop" @click.stop="closeMenu"></div>
    </transition>
    <transition name="menu">
      <div v-show="showMenu" class="menu__content" :class="`menu__content--${position}`">
        <slot name="menu-content"></slot>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
    showDropdownIcon: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'center',
    },
  },
  data() {
    return {
      showMenu: false,
      isMobileScreen: false,
    };
  },
  mounted() {
    this.checkScreenWidth();
    window.addEventListener('resize', this.checkScreenWidth);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkScreenWidth);
  },
  methods: {
    checkScreenWidth() {
      this.isMobileScreen = window.innerWidth < 1200;
    },
    closeMenu() {
      this.showMenu = false;
    },
    closeMenuOnHoverLost() {
      if (this.isMobileScreen) {
        return;
      }

      this.showMenu = false;
    },
    openMenuOnClick() {
      this.showMenu = true;
    },
    openMenuOnHover() {
      if (!this.isMobileScreen) {
        this.showMenu = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.menu {
  position: relative;
}

.menu__trigger {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.menu__trigger--inverted {
  color: var(--color-white);
}

.menu__trigger--interactive {
  color: var(--color-primary);
}

.menu__content {
  background-color: var(--color-white);
  box-shadow: var(--box-shadow-higher);
  padding: var(--space-large);
  position: absolute;
  top: calc(100% + var(--space-small));
  width: 280px;
  z-index: 3;

  &::before {
    border-color: transparent transparent var(--color-white) transparent;
    border-style: solid;
    border-width: var(--space-small);
    content: '';
    left: auto;
    position: absolute;
    top: calc(#{var(--space-small)} * -2);
  }

  &::after {
    content: '';
    height: var(--size-small);
    left: 0;
    position: absolute;
    top: calc(var(--space-extra-small) * -1);
    width: 100%;
  }

  @media screen and (max-width: $screen-md-max) {
    box-shadow: none;
    height: 100%;
    position: fixed;
    right: 0;
    top: 0;
    transform: translateX(0);
    z-index: 2;
  }
}

.menu__content--center {
  right: 50%;
  transform: translateX(50%);

  &::before {
    right: 50%;
    transform: translateX(50%);
  }

  @media screen and (max-width: $screen-md-max) {
    right: 0;
    transform: translateX(0);
  }
}

.menu__content--left {
  right: 0;
  transform: translateX(0);

  &::before {
    right: var(--space-small);
  }
}

.menu-enter-active, .menu-leave-active {
  transition: all var(--parameter-transition-speed);
}

.menu-enter, .menu-leave-to {
  opacity: 0;

  @media screen and (max-width: $screen-md-max) {
    right: -100%;
  }
}

.menu__trigger__dropdown-icon {
  margin-left: var(--space-small);

  @media screen and (max-width: $screen-md-max) {
    display: none;
  }
}

.menu__backdrop {
  @media screen and (max-width: $screen-md-max) {
    background-color: var(--color-gray-800);
    height: 100%;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 2;
  }
}

.backdrop-enter-active, .backdrop-leave-active {
  @media screen and (max-width: $screen-md-max) {
    transition: all var(--parameter-transition-speed);
  }
}

.backdrop-enter, .backdrop-leave-to {
  @media screen and (max-width: $screen-md-max) {
    opacity: 0;
  }
}
</style>
